<template>
  <BLayoutExpansionTableAsync
    title="Пользователи"
    type-autocomplete="users"
    type-table="participants-users"
    name="users-participants"
    :readonly="readonly"
    :value="list"
    :pagination="pagination"
    :ordering="filters.ordering"
    :loading="isLoading || isLoadingAsyncData"
    :skeleton="skeleton"
    :actions="customActions"
    return-object
    @change:pagination="onChangePagination"
    @change:sort="onChangeSort"
    @action:delete="onRemove"
    @action:append="onAppend"
  />
</template>

<script>
import { createListMixin } from '@/helpers/mixins/createListMixin'
import { ParticipantsUsersModel as Model } from './Model'
import {
  participantsUsersStoreModule as StoreModule,
} from './store'

import { ParticipantsApi } from '@/api/resources'
import BLayoutExpansionTableAsync
  from '@/components/layouts/BLayoutExpansionTableAsync.vue'
import { createModalRemove } from '@/helpers/createModalRemove'
import {
  createEdit,
  DELETE,
} from '@/helpers/enums/table-actions'
import { USERS_ROUTES as ROUTES } from '@/views/Users/utils'


const mixinOptions = { Model, StoreModule }
const listMixin = createListMixin(mixinOptions)

/** @typedef { import('@/helpers/mixins/createListMixin').ListMixin<any, StoreModule> } List */

export default {
  name: 'ViewParticipantsUsersList',
  components: {
    BLayoutExpansionTableAsync,
  },
  mixins: [
    listMixin,
  ],
  props: {
    participants_id: {
      type: [Number, String],
      required: true,
    },
    skeleton: Boolean,
    readonly: Boolean,
  },
  data: (vm) => ({
    isLoading: false,
    defaultParams: {
      participants_id: vm.participants_id,
    },
  }),
  computed: {
    customActions() {
      // Создаем действия без кнопки авторизации за пользователя
      const getEditRoute = (data) => ({
        name: ROUTES.EDIT,
        params: { id: data.id },
      })

      return [
        createEdit(getEditRoute),
        DELETE,
      ]
    },
  },
  methods: {
    async onAppend(data) {
      const api = new ParticipantsApi()

      this.isLoading = true
      try {
        await api.addUser(this.participants_id, { user_id: data.id })

        this.asyncData()
      } catch (e) {
        this.$notice.errors(e)
      }
      this.isLoading = false
    },
    async onRemove(data, callback) {
      const propsData = {
        titleText: 'Удаление участника',
        mainText: `Вы действительно хотите удалить участника "${data.full_name || data.username}"?`,
        errorText: 'Ошибка удаления участника',
        disableSuccessNotification: true,
        action: async () => {
          const unwatch = callback?.()
          const api = new ParticipantsApi()
          this.isLoading = true
          try {
            await api.removeUser(this.participants_id, { user_id: data.id })
          } catch (e) {
            this.$notice.errors(e)
            throw e
          } finally {
            unwatch?.()
            this.isLoading = false
            this.asyncData()
          }
        },
      }

      const modal = await createModalRemove(this, propsData)
      await modal.open()
    },
  },
}
</script>
